import { render } from "./PoliciesView.vue?vue&type=template&id=6a6324d0&scoped=true&ts=true"
import script from "./PoliciesView.vue?vue&type=script&lang=ts"
export * from "./PoliciesView.vue?vue&type=script&lang=ts"

import "./PoliciesView.vue?vue&type=style&index=0&id=6a6324d0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a6324d0"]])

export default __exports__